(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-with-tab"] && !Shopify.designMode) return;
  try {
    

const tabs = document.querySelectorAll('.tab_btn')
const sliders = document.querySelectorAll('.collection_slider')

tabs.forEach(btn => {

  btn.addEventListener('click', ()=>{

    const tab = btn.dataset.tab

    tabs.forEach(b=>b.classList.remove('active'))
    btn.classList.add('active')

    sliders.forEach(slider=>{

      if(slider.dataset.tab === tab){
        slider.style.display = 'block'
      }else{
        slider.style.display = 'none'
      }

    })

  })

})


  } catch(e) { console.error(e); }
})();
})();
